import { TrackingInformationState } from 'components/search/expedia/interfaces';

import { IProgramRelationship } from 'models';

function getInitialTrackingInformationState(activeProgram: IProgramRelationship): TrackingInformationState {
  return {
    trackingInformationPZCamref: activeProgram?.camRef ?? '',
    trackingInformationPZPubref: '',
  };
}

export { getInitialTrackingInformationState };
